<div class="navigation-bar">
    <a [routerLink]="['/providers']" routerLinkActive="router-link-active">
        <div class="icon-cls">
            <fa-icon [icon]="search"></fa-icon>
        </div>
    </a>
    <a [routerLink]="['/paymenthistory']" routerLinkActive="router-link-active">
        <div class="icon-cls">
            <fa-icon [icon]="history"></fa-icon>
        </div>
    </a>
</div>